export interface BonusItem {
  title: string
  body: string
  value: string
  image: string
}

export const bonusItems: BonusItem[] = [
  {
    title: '500 Frases más usadas',
    body: '500 frases más usadas con su pronunciación. Aprende frases útiles para conversaciones, viajes, trabajo, mensajes y situaciones cotidianas.',
    value: '$9500',
    image: 'https://cdn.magicpatterns.com/uploads/iGReT2Tut83tESkb7zvxhf/bono1.png',
  },
  {
    title: 'English Practice Master Kit',
    body: '200 Ejercicios Prácticos A1–C2 + Respuestas.',
    value: '$15000',
    image: 'https://cdn.magicpatterns.com/uploads/8a4TC5SVP1jN7KL3iqgYoc/bono2.png',
  },
  {
    title: '100 Verbos Frasales Esenciales',
    body: '100 verbos más utilizados en inglés real, con su significado, ejemplos y aplicaciones cotidianas.',
    value: '$12500',
    image: 'https://cdn.magicpatterns.com/uploads/vFgxMRbmzrTZJjpLnifkQ8/bono3.png',
  },
]
